import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PricebookRow } from './pricebook-row.model';
import { HttpClient } from '@angular/common/http';
import { IPagedDataTable } from '../../common/interfaces/IPagedDataTable.interface';
import { IDataTableService } from '../../common/interfaces/IDataTableService.interface';
import { DataTableFilter } from '../../common/models/DataTableFilter.model';
import { UrlPrefix } from "../../common/constants/url-prefix.constants";
import { map } from 'rxjs/operators';

@Injectable()
export class PricebookDataTableService implements IDataTableService<PricebookRow> {

  constructor(private http: HttpClient) { }


  public  getRows(filter: DataTableFilter): Observable<IPagedDataTable<PricebookRow>> {
    return this.http.get<IPagedDataTable<PricebookRow>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/pricebook/lookup?${filter.toQueryString()}`)
    .pipe(map((rows: IPagedDataTable<PricebookRow>) => {
      rows.pagedRecords.forEach(row => {
        row.rowIdentifier = row.id + '_' + (row.tableEntryId ?? 0);
      });
      
      return rows;
    }));;
  }

  public save(rows: Array<PricebookRow>): Observable<void> {
    return this.http.put<void>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/pricebook/lookup`, JSON.stringify(rows));
  }

}
